import a from "react";
import e from "prop-types";
import { I as n } from "./IconButton-C3Bh2v_G.es.js";
import { p as i } from "./utils-B8CGXZ5v.es.js";
import './ArrowWrapper.css';const l = "25", c = "#666", d = "#2b2b2b", s = "ArrowWrapper-module__nav___H6gkh", m = "ArrowWrapper-module__arrowButton___CS2ZB", o = {
  arrowSize: l,
  iconColor: c,
  iconHoverColor: d,
  nav: s,
  arrowButton: m
}, t = (r) => /* @__PURE__ */ a.createElement("nav", { className: o.nav }, /* @__PURE__ */ a.createElement(
  n,
  {
    className: o.arrowButton,
    style: {
      left: 0,
      transform: "scaleX(-1)",
      ...r.hideBack ? { visibility: "hidden" } : {}
    },
    color: o.iconColor,
    hoverColor: o.iconHoverColor,
    onClick: r.onBack,
    label: "back",
    size: i(o.arrowSize),
    name: "next",
    tabIndex: r.rangeMode ? -1 : 0
  }
), /* @__PURE__ */ a.createElement(
  n,
  {
    className: o.arrowButton,
    style: {
      right: 0,
      ...r.hideForward ? { visibility: "hidden" } : {}
    },
    color: o.iconColor,
    hoverColor: o.iconHoverColor,
    onClick: r.onForward,
    label: "forward",
    size: i(o.arrowSize),
    name: "next",
    tabIndex: r.rangeMode ? -1 : 0
  }
), r.children);
t.propTypes = {
  hideBack: e.bool.isRequired,
  hideForward: e.bool.isRequired,
  onBack: e.func.isRequired,
  onForward: e.func.isRequired,
  children: e.node.isRequired,
  rangeMode: e.bool
};
t.defaultProps = {
  rangeMode: !1
};
export {
  t as A
};
